import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'

export const createBaseEventParameterModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BaseEventParameterModal" */
    './BaseEventParameterModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
